"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.openShorthand = void 0;
var tokenizers_1 = require("../tokenizers");
var shorthand_mapper_1 = require("./shorthand-mapper");
var createSimpleApi = function (map) {
    return ({
        isExpression: function (item) { return map.has(item); },
        getValue: function (item) { return map.get(item) || []; },
        toString: function (item) { return item.text; },
    });
};
var createOpenPropAst = function (prop) {
    return function (ast, map, shallow) {
        if (map === void 0) { map = new Map(); }
        if (shallow === void 0) { shallow = false; }
        return (0, shorthand_mapper_1.getShorthandOpener)(prop)(ast, createSimpleApi(map), shallow);
    };
};
var openShorthand = function (prop, value) {
    var openPropAst = createOpenPropAst(prop);
    var ast = (0, tokenizers_1.createCssValueAST)(value);
    var openedShorthandRes = openPropAst(ast);
    var openedShorthandArray = (Array.isArray(openedShorthandRes) ? openedShorthandRes : [openedShorthandRes]);
    return openedShorthandArray;
};
exports.openShorthand = openShorthand;
//# sourceMappingURL=shorthand-isolated-parser.js.map